<template>
  <div>
    <div v-if="authState.userData.username">
      <img
          :src="authState.userData.photo100"
          class="img-circle"
          height="45"
          width="45"
      >

      <div class="login-data">
        <div class="login-data__username" >
          <router-link :to="{ name: 'account' }"  >
            {{ authState.userData.riderFullName }}
          </router-link>
        </div>
        <div class="login-data__bonuses">
          <router-link :to="{ name: 'bonuses' }">
            {{ authState.userData.displayedBonuses }}
          </router-link>
        </div>
      </div>

      <i class="bx bx-power-off logout" @click="logout"/>
    </div>
    <div v-else class="login-data__auth" @click="openLoginModal">
      Авторизация
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent} from "vue"
import authStore from "@/store/auth.ts"

export default defineComponent({
  name: 'LoginInfo',
  setup() {
    const {
      authState,
      authByVk,
      logout,
      loginFormState,
      openLoginModal
    } = authStore

    return {
      authByVk,
      authState,
      logout,
      loginFormState,
      openLoginModal
    }
  }
})
</script>

<style scoped>
.auth-info {
  font-size: 1.3rem!important;
  font-family: "Raleway", sans-serif;
}

.img-circle {
  border-radius: 50%;
}

.login-data {
  display: inline-block;
  vertical-align: middle;
  margin: 0 10px 0 15px;
}

.login-data__username, .login-data__auth {
  font-size: 1.1rem;
  font-family: "Raleway", sans-serif;
  cursor: pointer;
}

.login-data__bonuses {
  font-size: 12px
}

.logout {
  vertical-align: middle;
  color: #d9534f !important;
  font-size: 30px;
  cursor: pointer;
}

.login-data__username a {
  color: #fff;
}
</style>
